<div class="staff-search">
  <div class="k-mb-4">

    <form class="k-d-flex k-grid-cols-3" [formGroup]="staffForm" (ngSubmit)="onStaffSearch()">
      <kendo-formfield class="k-mr-4 k-w-full">
        <kendo-floatinglabel text="Staff First Name">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" [class]="'k-pr-2'" formControlName="firstName"
            [disabled]="disableSearch">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ staffForm.get('firstName')?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="k-mr-4 k-w-full">
        <kendo-floatinglabel text="Staff Last Name">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" formControlName="lastName"
            [disabled]="disableSearch">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ staffForm.get('lastName')?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="k-mr-4 k-w-full">
        <kendo-floatinglabel text="Staff ID">
          <kendo-textbox [clearButton]="true" [fillMode]="'outline'" formControlName="loginId"
            [disabled]="disableSearch">
          </kendo-textbox>
        </kendo-floatinglabel>
      </kendo-formfield>

      <button kendoButton [fillMode]="'solid'" [themeColor]="'primary'"
        class="k-h-fit k-align-self-start k-flex-grow k-mt-8" [disabled]="disableSearch">

        Search
      </button>
    </form>
    <kendo-formerror *ngIf="staffForm.invalid  && showSearchError">
      Please input Staff name or ID to search</kendo-formerror>
  </div>

  <div class="spinner" *ngIf="loadingPanelVisible">
    <kendo-loader type="infinite-spinner" themeColor="primary" size="large">
    </kendo-loader>
  </div>

  <kendo-grid [data]="gridData" *ngIf="gridData" scrollable="none">
    <kendo-grid-column field="loginId" title="Staff ID" [headerClass]="'header-bg-color'">
    </kendo-grid-column>
    <kendo-grid-column field="fullName" title="Staff Name" [headerClass]="'header-bg-color'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.fullName">{{ dataItem?.fullName }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="title" title="Title" [headerClass]="'header-bg-color'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.title">{{ dataItem?.title }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="locationName" title="Location" [headerClass]="'header-bg-color'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.locationName">{{ dataItem?.locationName }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Actions" headerClass="action-column" [headerClass]="'header-bg-color'">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button kendoButton fillMode="solid" themeColor="primary" (click)="onselectStaff(rowIndex)">
          {{ selectedStaff ? reselect : select }}
        </button>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
      <p *ngIf="!loadingPanelVisible">No Staff records available</p>
    </ng-template>
  </kendo-grid>

  <div class="subsection" *ngIf="selectedStaff && showSelectedStaffInfo && isSearchVisible">
    <h4 class="subsection__heading">Selected Staff</h4>
    <div class="k-mt-2" [formGroup]="selectedStaffForm" style="display: flex; flex-wrap: wrap; gap: 1%;">
      <div style="flex: 1;">
        <kendo-formfield>
          <kendo-floatinglabel text="Full Name">
            <kendo-textbox [clearButton]="false" [fillMode]="'outline'" formControlName="fullName" [disabled]="true"
              #fullName class="disabled">
            </kendo-textbox>
          </kendo-floatinglabel>
        </kendo-formfield>
      </div>
      <div style="flex: 1;">
        <kendo-formfield>
          <kendo-floatinglabel text="Phone *">
            <kendo-maskedtextbox [fillMode]="'outline'" formControlName="phone" [disabled]="true" mask="(000) 000-0000"
              [readonly]="readOnly" #phone>
            </kendo-maskedtextbox>
          </kendo-floatinglabel>
          <kendo-formerror>{{ selectedStaffForm.get('phone')?.errors?.validatePhoneNumberMaskedTextBox?.message
            }}</kendo-formerror>
        </kendo-formfield>
      </div>
    </div>

    <ng-container *ngIf="showSchool">
      <div [formGroup]="selectedStaffForm">
        <div class="k-mt-2">
          <div class="k-d-inline-block ip-control k-pr-4 k-w-full">
            <kendo-formfield>
              <kendo-floatinglabel text="School">
                <kendo-textbox [clearButton]="true" [fillMode]="'outline'" formControlName="school" #school>
                </kendo-textbox>
              </kendo-floatinglabel>
              <kendo-formerror *ngIf="selectedStaffForm.get('school')?.hasError('required')">
                Error: This field is required
              </kendo-formerror>
            </kendo-formfield>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="showEmail">
      <div class="k-mt-2" [formGroup]="selectedStaffForm">
        <div class="k-d-inline-block ip-control" [formGroup]="selectedStaffForm" [style.width.%]="49">
          <kendo-formfield>
            <kendo-floatinglabel text="Email Address *">
              <kendo-textbox [clearButton]="true" [fillMode]="'outline'" [disabled]="false" formControlName="email"
                [readonly]="readOnly" #email>
              </kendo-textbox>
            </kendo-floatinglabel>
            <kendo-formerror>
              {{ selectedStaffForm.get('email')?.errors?.validateEmail?.message }}
            </kendo-formerror>
          </kendo-formfield>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showAddress">
      <div [formGroup]="selectedStaffForm">
        <div class="k-mt-2">
          <div class="k-d-inline-block ip-control k-pr-4" [style.width.%]="70">
            <kendo-formfield>
              <kendo-floatinglabel text="Street Address *">
                <kendo-textbox [clearButton]="true" [fillMode]="'outline'" [disabled]="false"
                  formControlName="streetAddress1" #streetAddrees>
                </kendo-textbox>
              </kendo-floatinglabel>
              <kendo-formerror *ngIf="selectedStaffForm.get('streetAddress1')?.hasError('required')">
                Error: This field is required
              </kendo-formerror>
            </kendo-formfield>
          </div>
        </div>
      </div>
    </ng-container>
    <button *ngIf="!disableSearch" kendoButton class="k-my-4" (click)="resetSearch()" fillMode="outline"
      themeColor="primary">Reset Search</button>
  </div>